import { Location, matchPath } from 'react-router-dom';

import { getEnvConfig } from '../envs/envConfig';
import { Route } from '../envs/types';

export function getRemoteRoute<ROUTE extends Route>(pathname: string) {
  const { remoteRoutes } = getEnvConfig();
  return remoteRoutes?.find((route) => matchPath(route.path, pathname)) as
    | ROUTE
    | undefined;
}

export default function getCurrentRoute<ROUTE extends Route>(
  location: Location,
): ROUTE | undefined {
  return getRemoteRoute(location.pathname);
}
